<template>
	<AppDialog :dialogName="'Name your mapping block'" width="600">
		<template v-slot:header>
			<DialogHeader :service="service" :fieldItem="fieldItem" />
		</template>
		<div class="dynamic-data-mapper-dialog">
			<div class="dialog-title">2. Name your mapping block</div>
			<div class="dialog-description">Try the plural name of the item type. If you're not sure, leave empty.</div>
			<div class="dialog-body">
				Mapping block name
				<AppTextField class="url-input" outlined dense v-model="localTitle" hide-details single-line />
			</div>

			<div class="dialog-bottom">
				<SecondaryButton class="display-flex center-margin" @click="save" :loading="isSaving">Save</SecondaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

import { mapActions, mapGetters } from 'vuex';
import { getConfigurationAndInterfaceIdByFieldUUID } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
import { saveWidget } from '@/store/modules/widgets/actions';
import { getWidget } from '@/store/modules/widgets/getters';
import { editedWorkflowVersion } from '@/store/modules/selectedWorkflow/getters';
import WidgetService from '@/utils/WidgetService';
import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';

import AppDialog from '../AppDialog/AppDialog';
import DialogHeader from './common/DialogHeader';

export default {
	name: 'TitleSelectionForMappingDialog',
	components: {
		AppDialog,
		DialogHeader,
	},
	props: {
		action: { type: Object },
		service: { type: Object },
		interfaceFieldUUID: { type: String },
		fieldItem: { type: String },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		...mapGetters([getConfigurationAndInterfaceIdByFieldUUID.fullPath, getWidget.fullPath, editedWorkflowVersion.fullPath]),
		configurationAndInterfaceIdByFieldUUID() {
			return this[getConfigurationAndInterfaceIdByFieldUUID.fullPath](this.interfaceFieldUUID);
		},
		interfaceUUID() {
			return this.configurationAndInterfaceIdByFieldUUID.interfaceUUID;
		},
		interface() {
			return this[getWidget.fullPath](this.interfaceUUID);
		},
		mappingField() {
			return this.interface.fields.find((x) => x.id === this.interfaceFieldUUID);
		},
	},
	methods: {
		...mapActions([saveWidget.fullPath]),
		close() {
			this.dialogPromiseHandlers.resolve();
			return AppDialogManagerService.closeCurrentDialog();
		},
		async save() {
			this.$set(this, 'isSaving', true);
			await this.saveFieldInMapperWidgetField(this.localTitle);
			this.close();
			const { service, fieldItem } = this;
			AppDialogManagerService.openFinishedCreatingMapperDialog({ service, fieldItem });
		},
		async saveFieldInMapperWidgetField(widgetFieldTitle) {
			const currentInterface = cloneDeep(this.interface);
			await WidgetService.saveFieldInMapperWidgetField(
				'field_title',
				widgetFieldTitle,
				currentInterface,
				this[editedWorkflowVersion.fullPath]?.id,
				this.interfaceFieldUUID,
				this[saveWidget.fullPath]
			);
		},
	},
	mounted() {
		this.$set(this, 'localTitle', this.mappingField.metadata.source.field_title);
	},
	data() {
		return {
			localTitle: '',
			isSaving: false,
		};
	},
};
</script>
